// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  name: 'Production',
  API_WEB: 'https://hb-prd.hbpooling.com.br',
  API: 'https://api-tracer.hbpooling.com.br',
  //  API: 'http://localhost:3000',
  WEB: 'https://tracer.hbpooling.com.br/',
  WEBHB: 'https://integrador.hbpooling.com.br/',
  firebaseConfig: {
    apiKey: "AIzaSyA69mWIy2XJh6Z9L56QeeAsgHwrJMOzfZk",
    authDomain: "hbgo-d9c2c.firebaseapp.com",
    projectId: "hbgo-d9c2c",
    databaseURL: "https://hbgo-d9c2c-default-rtdb.firebaseio.com",
    storageBucket: "hbgo-d9c2c.appspot.com",
    messagingSenderId: "1022503859869",
    appId: "1:1022503859869:web:83dcbeba064844c1210674",
    measurementId: "G-4SF52XDH0G"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
